// extracted by mini-css-extract-plugin
export var danger = "_17-6";
export var lightPink = "_17-a";
export var medium = "_17-j";
export var nearSquare = "_17-m";
export var neutralBlue = "_17-8";
export var neutralYellow = "_17-7";
export var noCapitalize = "_17-1";
export var normal = "_17-2";
export var pill = "_17-0";
export var primary = "_17-3";
export var primaryLight = "_17-4";
export var shadow = "_17-n";
export var small = "_17-k";
export var solidBlack = "_17-i";
export var solidGreen = "_17-d";
export var solidLightBlue = "_17-f";
export var solidNavy = "_17-e";
export var solidOrange = "_17-h";
export var solidPink = "_17-g";
export var solidRed = "_17-b";
export var solidWhite = "_17-9";
export var solidYellow = "_17-c";
export var success = "_17-5";
export var xsmall = "_17-l";